import { register, CloudObject, defineProperty } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class ApplicationEvent extends CloudObject {

    /**
     * Creates an instance of ApplicationEvent.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(ApplicationEvent);
    }
    
    /**
     * @return {string}
     */
    getPayload() {
        return this.get(ApplicationEvent.payloadProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observePayload($) {
        return this.observe($, ApplicationEvent.payloadProp);
    }

    /**
     * @return {string}
     */
    getEventCode() {
        return this.get(ApplicationEvent.eventCodeProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeEventCode($) {
        return this.observe($, ApplicationEvent.eventCodeProp);
    }

    /**
     * @return {string}
     */
    getMessage() {
        return this.get(ApplicationEvent.messageProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeMessage($) {
        return this.observe($, ApplicationEvent.messageProp);
    }

    /**
     * @return {string}
     */
    getEventType() {
        return this.get(ApplicationEvent.eventTypeProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeEventType($) {
        return this.observe($, ApplicationEvent.eventTypeProp);
    }

    /**
     * @return {Date}
     */
    getCreatedOn() {
        return this.get(ApplicationEvent.createdOnProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<Date>}
     */
    observeCreatedOn($) {
        return this.observe($, ApplicationEvent.createdOnProp);
    }

    /**
     * @return {string}
     */
    getCreatedBy() {
        return this.get(ApplicationEvent.createdByProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeCreatedBy($) {
        return this.observe($, ApplicationEvent.createdByProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setPayload(transaction, instance, value) {
        transaction.update(instance, ApplicationEvent.payloadProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setEventCode(transaction, instance, value) {
        transaction.update(instance, ApplicationEvent.eventCodeProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setMessage(transaction, instance, value) {
        transaction.update(instance, ApplicationEvent.messageProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setEventType(transaction, instance, value) {
        transaction.update(instance, ApplicationEvent.eventTypeProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {Date} value
     */
    static setCreatedOn(transaction, instance, value) {
        transaction.update(instance, ApplicationEvent.createdOnProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setCreatedBy(transaction, instance, value) {
        transaction.update(instance, ApplicationEvent.createdByProp, value);
    }

}

// Hardcoded tags
register('01998623077bea60b088', ApplicationEvent);
ApplicationEvent.payloadProp = defineProperty('01998623334b6dd613ec');
ApplicationEvent.eventCodeProp = defineProperty('01998623a02ac3de9cab');
ApplicationEvent.messageProp = defineProperty('01998623c33ce721d71a');
ApplicationEvent.eventTypeProp = defineProperty('019986242270d430b85e');
ApplicationEvent.createdOnProp = defineProperty('0199863214ee7ec5ef9a');
ApplicationEvent.createdByProp = defineProperty('0199b98f1ea581d86d6b');
